const breakpoints = [1200, 992, 768, 576];

export const mq = breakpoints.map(
  bp => `@media (max-width: ${bp}px)`
);